module.exports = __webpack_public_path__ + "img/darknstormy.5f5e670b.jpg";